export const STEP_TO_EVENT_MAP = {
  package_selection: 'add_to_cart',
  choose_centre: 'begin_checkout',
  personal_details: 'add_shipping_info',
  safety_questions: 'add_payment_info'
};

export const PACKAGE_MATRIX = {
  'full-body-mri-base': { sku: 'pid_1', anonymizedAdId: 'pid_a1b2c3d4e5f6g7h8', name: 'Base Scan', category: 'Full Body MRI' },
  'full-body-mri-plus': { sku: 'pid_2', anonymizedAdId: 'pid_f9e8d7c6b5a4b3c2', name: 'Plus Scan', category: 'Full Body MRI' },
  'full-body-mri-comprehensive': { sku: 'pid_3', anonymizedAdId: 'pid_1a2b3c4d5e6f7g8h', name: 'Comprehensive Scan', category: 'Full Body MRI' }
};
